import { render, staticRenderFns } from "./SageDepartmentsSettings.vue?vue&type=template&id=57fb587b&scoped=true&"
import script from "./SageDepartmentsSettings.vue?vue&type=script&lang=js&"
export * from "./SageDepartmentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb587b",
  null
  
)

export default component.exports